import React from 'react';
import {connect} from 'react-redux';
// GuideStepInfo imports
import Title from './title';
import InputContainer from './inputContainer';
import ButtonsContainer from './buttonsContainer';
// GameGuide imports
import GuideStepContainer from '../layout';
import PublishSuccess from './publishSuccess';
// Shared imports
import { GuidePublishState } from '../../../shared';

class GuideStepInfo extends React.Component {
    isPublished = () => {
        const { gameGuide } = this.props;
        return gameGuide.publishState & GuidePublishState.SUCCESS;
    }

    render = () => {
        const { id } = this.props;

        if(this.isPublished()) {
            return (
                <GuideStepContainer title="" id={id}>
                    <PublishSuccess />
                </GuideStepContainer>
            );
        }

        return (
            <GuideStepContainer titleElement={<Title />} id={id} hasSaveButton>
                <InputContainer />
                <ButtonsContainer />
            </GuideStepContainer>
        );
    }
}

GuideStepInfo.defaultProps = { 
    id: ''
};

const mapStateToProps = state => ({
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps
)(GuideStepInfo);